/**
 * 참고 : https://github.kakaocorp.com/kakaopage/karina/blob/develop/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/ViewType.kt#L3
 */
export enum ViewTypeVo {
  SeriesCardView = 'series_card_view',
  SingleCardView = 'single_card_view',
  SeriesPosterView = 'series_poster_view',
  SinglePosterView = 'single_poster_view',
  SeriesCleanView = 'series_clean_view',
  SingleCleanView = 'single_clean_view',
  SeriesListView = 'series_list_view',
  SingleListView = 'single_list_view',
  // banners
  SquareView = 'square_view',
  RectangleView = 'rectangle_view',
  StrategyView = 'strategy_view',
  BannerLineView = 'banner_line_view',
  BannerPromotionView = 'banner_promotion_view',
  BannerCardView = 'banner_card_view',
}
